<script setup lang="ts">
import type { CardPriceControl } from "../cardPrice";

defineProps<{ control: CardPriceControl }>();
</script>

<template>
	{{ control.prefix }} {{ control.price }}
</template>
